import { Component, Input } from '@angular/core';
import { patientInitials } from '../../util/PatientData';

/**
 * Cuadro del paciente: su foto si la tiene, si no sus iniciales (nombre y apellido).
 * La foto siempre llega cuadrada desde el recortador, así que nunca se deforma.
 */
@Component({
  selector: 'app-patient-avatar',
  template: `<div class="pav" [style.width.px]="size" [style.height.px]="size" [style.font-size.px]="size * 0.375" [style.border-radius.px]="size * 0.29">
               <img *ngIf="photoUrl && !photoFailed; else initials" [src]="photoUrl" alt="Foto del paciente" (error)="photoFailed = true">
               <ng-template #initials>{{ initialsText }}</ng-template>
             </div>`,
  styleUrls: ['./patient-avatar.component.css']
})
export class PatientAvatarComponent
{
  @Input() public name: string;
  @Input() public lastName: string;
  @Input() public size: number = 48;

  private _photoUrl: string;
  @Input() set photoUrl(value: string)
  {
    this._photoUrl = value;
    this.photoFailed = false;
  }
  get photoUrl(): string { return this._photoUrl; }

  // Si la foto no carga se regresa a las iniciales en vez de dejar un ícono roto
  public photoFailed: boolean = false;

  get initialsText(): string
  {
    return patientInitials(this.name, this.lastName);
  }
}
